import {createRouter, createWebHistory} from "vue-router";
// import GuiView from '@/pages/GuiView.vue'
import KsjPage from "@/create/pages/KsjPage.vue";
import JbgPage from "@/create/pages/JbgPage.vue";
import ThlPage from "@/create/pages/ThlPage.vue";
import ReqPage from "@/create/pages/ReqPage.vue";
import ActPage from "@/create/pages/ActPage.vue";
import Athletes from "@/create/pages/Athletes.vue";
import AthletesRegs from "@/create/pages/AthletesRegs.vue";
import FinalPage from "@/create/pages/FinalPage.vue";
import ATB from "@/create/pages/landings/ATB.vue";
import ATB_info from "@/create/pages/atb/ATB_info.vue";
import OTP from "@/create/pages/landings/OTP.vue";

const routes = [
    {
        path: "/ksj",
        component: KsjPage,
    },
    {
        path: "/",
        redirect: "/ksj",
    },
    {
        path: "/athletes",
        component: Athletes,
    },
    {
        path: "/athletes/registration",
        component: AthletesRegs,
    },
    {
        path: "/jbg",
        component: JbgPage,
    },
    {
        path: "/thl",
        component: ThlPage,
    },
    {
        path: "/requisites/:id",
        component: ReqPage,
        props: true,
    },
    {
        path: "/transfer",
        component: ActPage,
    },
    {
        path: "/final/:slugID",
        component: FinalPage,
    },
    // {
    //   path: '/gui',
    //   component: GuiPage
    // },
    {
        name: "landing-ATB-insurance",
        path: "/atb-insurance/",
        component: ATB_info,
    },

    // ------------------- лендинги ниже --------------------
    {
        name: "landing-ATB",
        path: "/atb/",
        component: ATB,
    },
    {
        name: "landing-OTP",
        path: "/otp/:id",
        component: OTP,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
